import { render } from "./LanguageItem.vue?vue&type=template&id=54b05fd9&scoped=true"
import script from "./LanguageItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./LanguageItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./LanguageItem.vue?vue&type=style&index=0&id=54b05fd9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b05fd9"]])

export default __exports__